import { backendApi } from "@api/base/backend";

export async function createPermission(name: string) {
  const data = await backendApi.callApi(
    "/admin/permissions",
    "POST",
    JSON.stringify({ name }),
  );

  return { data };
}

